<script>

export default {

    props: {
        title : String,
        value: Number,
        valueStr: String,
        min: Number
    },

    
    data () {
        return {

        }

    },
  };
</script>

<template>
  <div class="row">
    <div class="col-6">
      <span class="text-success font-weight-bold font-size-14">{{this.title}}</span>
    </div>
    
    <div class="col-6 text-right">
      <span :class="value<min ? 'text-danger' : 'text-success'" class="font-weight-bold font-size-12"><i :class="value<min ? 'fas fa-exclamation-triangle' : 'fas fa-check'" /> {{valueStr}} / {{this.min}} TND HT</span>
    </div>
  </div>
</template>
